import { decodeUTMParamsData, getCookieName } from '@creditornot/cwc-cookie-sdk';
import { useEffect, useState } from 'react';
import { useCookie } from 'react-use';

import { SelfServeSignupTag } from './types';

const useCookieUtmTags = () => {
  const [utmTags] = useCookie(getCookieName('utm-params'));
  const [selfServeTags, setSelfServeTags] = useState<SelfServeSignupTag[]>([]);

  useEffect(() => {
    if (!utmTags) {
      setSelfServeTags([]);
      return;
    }

    const tagObj = decodeUTMParamsData(utmTags);

    if (!tagObj) {
      setSelfServeTags([]);
      return;
    }

    const utmCookieToPayloadNameMapping: Readonly<Record<string, string>> = {
      utmSource: 'utm_source',
      utmMedium: 'utm_medium',
      utmCampaign: 'utm_campaign',
      utmContent: 'utm_content',
      utmTerm: 'utm_term',
    };

    const ssTags = Object.entries(tagObj).reduce((acc, [key, value]) => {
      if (!value) {
        return acc;
      }

      const name: string | undefined = utmCookieToPayloadNameMapping[key];
      if (!name) {
        return acc;
      }

      return [...acc, { name, value }];
    }, [] as SelfServeSignupTag[]);

    setSelfServeTags(ssTags);
  }, [utmTags]);

  return selfServeTags;
};

export default useCookieUtmTags;
